import { render } from "./Step_one.vue?vue&type=template&id=da8b8f6c"
import script from "./Step_one.vue?vue&type=script&lang=js"
export * from "./Step_one.vue?vue&type=script&lang=js"

import "./Step_one.vue?vue&type=style&index=0&id=da8b8f6c&lang=less"
script.render = render

export default script